module.exports = __webpack_public_path__ + "static/media/rs-gh.9896749d.svg";